import React from 'react';

import { formatCurrency } from '@coingecko/cryptoformat';
import { CardContent, Stack, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';

import { CalendarIcon } from '../Icons/CalendarIcon';

import BrandCardHeader from './BrandCardHeader';
import { StyledCard, StyledCellText, StyledChip } from './styled';

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: 343,
    borderRadius: 20
  },
  content: {
    padding: 24
  },
  card: {
    position: 'relative',
    borderRadius: 16,
    padding: 12,
    minWidth: 300
  }
}));

// eslint-disable-next-line react/display-name
const IDOCard = React.memo((props) => {
  const {
    ticker,
    token_name,
    logo_url,
    launch_date,
    launch_end_date,
    launch_mkt_cap,
    ido_price,
    categories,
    investors,
    ecosystems,
    token_id
  } = props;
  const cardStyles = useStyles();

  const getDate = (date) => {
    return dayjs(date).utc().isValid() ? dayjs(date).utc().format('D MMM') : 'TBA';
  };

  const navigate = useNavigate();

  const getEcosystems = () => {
    const hiddenData = ecosystems?.length > 2 ? ecosystems?.slice(2) : [];
    const dataToBeShown = ecosystems.slice(0, 2);

    if (hiddenData.length > 0) {
      return (
        <Stack direction="row">
          {dataToBeShown.map((data, index) => (
            <StyledChip
              label={data.ecosys_name}
              fontColor={'#00a152'}
              key={index}
              variant="outlined"
              size="small"
            />
          ))}
          <Tooltip title={hiddenData.map((item) => item.ecosys_name).join('\n')}>
            <StyledChip
              label={`+${hiddenData.length}`}
              fontColor="#00a152"
              variant="outlined"
              size="small"
            />
          </Tooltip>
        </Stack>
      );
    } else {
      return (
        <>
          {dataToBeShown.map((data, index) => (
            <StyledChip
              label={data.ecosys_name}
              fontColor={'#00a152'}
              key={index}
              variant="outlined"
              size="small"
            />
          ))}
        </>
      );
    }
  };

  const getCategories = () => {
    const hiddenData = categories?.length > 1 ? categories?.slice(1) : [];
    const dataToBeShown = categories.slice(0, 1);

    if (hiddenData.length > 0) {
      return (
        <>
          <Stack direction="row">
            {dataToBeShown.map((data, index) => (
              <StyledChip
                label={data.category_name}
                fontColor="purple"
                key={index}
                variant="outlined"
                size="small"
              />
            ))}

            <Tooltip title={hiddenData.map((item) => item.category_name).join(' , ')}>
              <StyledChip
                label={`+${hiddenData.length}`}
                variant="outlined"
                fontColor={'#00a152'}
                size="small"
              />
            </Tooltip>
          </Stack>
        </>
      );
    } else {
      return (
        <>
          {dataToBeShown.map((data, index) => (
            <StyledChip
              label={data.category_name}
              fontColor="purple"
              key={index}
              variant="outlined"
              size="small"
            />
          ))}
        </>
      );
    }
  };

  const onCardClick = () => {
    navigate(`/tokenDetails/${token_name}`);
    localStorage.setItem('tokenId', token_id);
  };
  return (
    <StyledCard onClick={onCardClick}>
      <BrandCardHeader
        image={logo_url}
        extra={
          <>
            <Stack direction="row" gap={0.5}>
              <CalendarIcon />
              <Typography variant="body1">{getDate(launch_date)}</Typography>
              {'-'}
              <Typography variant="body1">{getDate(launch_end_date)}</Typography>
            </Stack>
          </>
        }
      />
      <Stack sx={{ ml: 2 }}>
        <Typography variant="title">{token_name}</Typography>
        <Typography variant="subtitle">{ticker}</Typography>
      </Stack>

      <CardContent className={cardStyles.content}>
        <Stack justifyContent="space-between" direction="row">
          <Typography>Category</Typography>
          <Stack direction="row">{getCategories()}</Stack>
        </Stack>

        <Stack justifyContent="space-between" direction="row">
          <Typography>Initial M.Cap</Typography>
          <StyledCellText>{launch_mkt_cap && formatCurrency(launch_mkt_cap, 'USD')}</StyledCellText>
        </Stack>
        <Stack justifyContent="space-between" direction="row">
          <Typography>Initial Price</Typography>
          <StyledCellText> {ido_price && formatCurrency(ido_price, 'USD')}</StyledCellText>
        </Stack>

        <Stack justifyContent="space-between" direction="row">
          <Typography>Investors</Typography>
          <StyledCellText> {investors.length > 0 ? investors.length : ''}</StyledCellText>
        </Stack>
        <Stack justifyContent="space-between" direction="row">
          <Typography>Ecosystem</Typography>
          <Stack direction="row">{getEcosystems()}</Stack>
        </Stack>
      </CardContent>
    </StyledCard>
  );
});

export default IDOCard;
